<template>
  <!--  page starting div -->
  <div>
    <RecordNotFound
      v-if="status_code == 404"
      :message="status_message"
    ></RecordNotFound>
  <div v-else-if="is_no_records == 1">
    <GlobalEmptyRecord RouteName="AmcContractCreate">
      <template slot="title">
        <h2>Start your Amc Service here.</h2>
      </template>
      <template slot="content">
        <span style="color:gray">Option for Annual Maintainance Contract(AMC).</span>
      </template>
      <template slot="page">New AMC Contract</template>
    </GlobalEmptyRecord>
  </div>
  <div class="start-page" v-else style="margin-top:-10px !important">
    <template v-if="CheckedCount == 0">
      <b-row class="px-pad border-bottom" style="height:42px">
        <b-col cols="8" class="px-0">
          
          <b-dropdown
            variant="link"
            size="sm"
            class="index-filter-heading"
            dropdown
            toggle-class="text-decoration-none"
            :text="filter_name"
          >
            <div class="dropdownitem-list">
              <b-dropdown-item
                :class="{'filter_dropdown' : true}"
                :to="{ name : 'AmcContract',query: {page: 1 ,show: 10,search:'',status:status,sort:sort,label:label,status:item.status_id} }"
                v-for="item in filter_list"
                :key="item.status_id"
                v-if="item.status_name != filter_name"
              >{{ item.status_name }}</b-dropdown-item>
            </div>

            <b-dropdown-divider />
            <router-link
              class="event-link dropdown-item"
              :to="{ name : 'FilterCreate',params : {title :'AMC Contract',module:'amccontract',call:'fetchamccontractdetails',route:'amccontract'}}"
            >Add Custom Filter</router-link>
          </b-dropdown>
          <!-- edit button for custom filter dropdown -->
          <router-link
            class="event-link"
            v-if="status >= 100"
            :to="{ name : 'FilterUpdate',params : {id:getPresentValue(filter_list,'status_name',filter_name),title :'AMC Contract',module:'amccontract',call:'fetchamccontractdetails',route:'amccontract'}}"
          >
            <b-button size="xs" style="position:relative;bottom:4px;" variant="light">
              <i class="la la-edit la-lg"></i>
            </b-button>
          </router-link>
        </b-col>

        <b-col cols="4" class="text-right px-0">
          <router-link
            :to="{ name : 'AmcContractCreate'}"
            v-if="RoutePermission(true,'AmcContractCreate','','','')"
          >
            <b-button variant="primary" size="sm" class="mr-2">New AMC Contract</b-button>
          </router-link>
             <b-button variant="light" size="sm" class="mr-2" @click="getrefreshList()"> <i class="la la-refresh la-lg"></i></b-button>
          <b-dropdown variant="light" size="sm" class="no-caret-dropdown">
            <template slot="button-content">
              <i class="la la-navicon la-lg"></i>
            </template>
            <template v-if="RoutePermission(false,'','','settings','export')">
              <b-dropdown-item @click="exportModal()">
                <span class="no_caret_import la la-download mr-3"></span>Export AMC Contract
              </b-dropdown-item>

              <b-dropdown-divider />
            </template>
            <p class="fw-semi-bold theme-text-color ml-3">Add Columns</p>
            <div class="dropdownitem-block">
              <li class="ml-3">
                <b-form-checkbox name="amc_start_date" v-model="amc_start_date" value="1">Start Date</b-form-checkbox>
              </li>
              <li class="ml-3 pt-2">
                <b-form-checkbox
                  name="next_service_date"
                  v-model="next_service_date"
                  value="1"
                >Next Service Date</b-form-checkbox>
              </li>
              <li class="ml-3 pt-2">
                <b-form-checkbox name="cus_legacy_id" v-model="cus_legacy_id" value="3">Customer ID</b-form-checkbox>
              </li>
                <li class="ml-3 pt-2">
                <b-form-checkbox name="created_at" v-model="created_at" value="4">Created Time</b-form-checkbox>
              </li>
              <li class="ml-3 pt-2 pb-2">
                <b-form-checkbox name="updated_at" v-model="updated_at" value="5">Updated Time </b-form-checkbox>
              </li>
            </div>
          </b-dropdown>
        </b-col>
      </b-row>
    </template>
    <b-row>
      <b-col cols="12" class="px-0">
        <!--  row for bulk delete option and acitve and inactive if atleast one checkbox is selected in the table -->
        <b-row style="height:42px" class="px-pad border-bottom" v-if="CheckedCount > 0">
          <b-col xl="6" lg="6" md="6" sm="6" xs="6" cols="6" class="px-pad">
            <b-button
              size="sm"
              variant="light"
              class="text-left"
              @click="deletemodal"
              :disabled="!RoutePermission(false,'','','amccontract','delete')"
            >
              <i
                class="glyphicon glyphicon-trash"
                v-b-tooltip="!RoutePermission(false,'','invoice','amccontract','delete')?' You do not have permission to perform this operation. Please contact your Administrator. ':''"
              ></i>
            </b-button>
          </b-col>
          <b-col xl="6" lg="6" md="6" sm="6" xs="6" cols="6" class="px-pad">
            <i
              v-on:click="checkAll({
              target :{
                checked : false
              }
            }),CheckedCount = 0,checkboxes1[0] = false"
              class="la la-times-circle-o la-lg cursor_pointer float-right mar-top-close"
            ></i>
          </b-col>
        </b-row>
        <b-alert
          class="alert-transparent alert-shade mx-mar mt-3"
          :show="this.$route.params.search == '' ? false : true"
        >
          <router-link
            class="text-dark float-right"
            :to="{ name : 'AmcContract',query: {page: page ,show: count,search:'',sort:sort,label:label,custom:custom } }"
          >
            <i class="la la-remove la-lg text-decoration-none"></i>
          </router-link>
          <p>
            <span class="fw-semi-bold">Customer Name / Customer ID / Phone No / AMC No:</span>
            {{ this.$route.query.search }}
          </p>
        </b-alert>
        <div
          :class="this.$route.params.search=='' ?'table-responsive':'table_search'"
          id="scrollCol"
        >
          <table class="table table-hover index-table">
            <thead>
              <tr>
                <th style="width:54px !important">
                  <div class="abc-checkbox index-checkbox text-left">
                    <input
                      type="checkbox"
                      id="checkboxall"
                      v-model="checkboxes1[0]"
                      @change="event => checkAll(event)"
                    />
                    <label for="checkboxall" />
                  </div>
                </th>
                <th style="min-width:85px !important">
                  <router-link
                    class="text-dark text-decoration-none"
                    :to="{ name : 'AmcContract',query: {page: page,show: show,search:search_criteria,status:status,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'amc_no',custom:custom } }"
                  >
                    ID
                    <small class="text-muted" v-if="label == 'amc_no'">
                      <i
                        :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                        style="font-weight:thinner;"
                      ></i>
                    </small>
                  </router-link>
                </th>
                <th style="min-width:180px !important">
                  <router-link
                    class="text-dark text-decoration-none"
                    :to="{ name : 'AmcContract',query: {page: page,show: show,search:search_criteria,status:status,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'cus_name',custom:custom } }"
                  >
                    Customer
                    <small class="text-muted" v-if="label == 'cus_name'">
                      <i
                        :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                        style="font-weight:thinner;"
                      ></i>
                    </small>
                  </router-link>
                </th>
                <th style="min-width:150px !important" v-if="cus_legacy_id==3">Customer ID</th>
                <th style="min-width:180px !important">
                  <router-link
                    class="text-dark text-decoration-none"
                    :to="{ name : 'AmcContract',query: {page: page,show: show,search:search_criteria,status:status,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'pdt_name',custom:custom } }"
                  >
                    Product
                    <small class="text-muted" v-if="label == 'pdt_name'">
                      <i
                        :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                        style="font-weight:thinner;"
                      ></i>
                    </small>
                  </router-link>
                </th>

                <th class="text-right" style="min-width:140px !important">
                  <router-link
                    class="text-dark text-decoration-none"
                    :to="{ name : 'AmcContract',query: {page: page,show: show,search:search_criteria,status:status,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'amc_total',custom:custom } }"
                  >
                    Value
                    <small class="text-muted" v-if="label == 'amc_total'">
                      <i
                        :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                        style="font-weight:thinner;"
                      ></i>
                    </small>
                  </router-link>
                </th>
                <th class="text-right" style="min-width:140px !important">
                  <router-link
                    class="text-dark text-decoration-none"
                    :to="{ name : 'AmcContract',query: {page: page,show: show,search:search_criteria,status:status,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'total_avl_qty',custom:custom } }"
                  >
                    Avl Qty
                    <small class="text-muted" v-if="label == 'total_avl_qty'">
                      <i
                        :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                        style="font-weight:thinner;"
                      ></i>
                    </small>
                  </router-link>
                </th>
                <th style="min-width:140px !important" v-if="amc_start_date==1">Start date</th>
                <th style="min-width:140px !important" v-if="next_service_date==1">Next Service</th>
                <th style="min-width:140px !important">
                  <router-link
                    class="text-dark text-decoration-none"
                    :to="{ name : 'AmcContract',query: {page: page,show: show,search:search_criteria,status:status,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'amc_end_date',custom:custom } }"
                  >
                    Expiry Date
                    <small class="text-muted" v-if="label == 'amc_end_date'">
                      <i
                        :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                        style="font-weight:thinner;"
                      ></i>
                    </small>
                  </router-link>
                </th>
                <th style="min-width:110px !important">
                  <router-link
                    class="text-dark text-decoration-none"
                    :to="{ name : 'AmcContract',query: {page: page,show: show,search:search_criteria,status:status,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'amc_status',custom:custom } }"
                  >
                    Status
                    <small class="text-muted" v-if="label == 'amc_status'">
                      <i
                        :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                        style="font-weight:thinner;"
                      ></i>
                    </small>
                  </router-link>
                </th>
                  <th style="min-width:300px !important" v-if="created_at">
                  <router-link
                    class="text-dark text-decoration-none"
                    :to="{ name : 'AmcContract',query: {page: page,show: show,search:search_criteria,status:status,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'created_at',custom:custom } }"
                  >
                    Created time
                    <small class="text-muted" v-if="label == 'created_at'">
                      <i
                        :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                        style="font-weight:thinner;"
                      ></i>
                    </small>
                  </router-link>
                </th>
                <th style="min-width:300px !important" v-if="updated_at">
                  <router-link
                    class="text-dark text-decoration-none"
                    :to="{ name : 'AmcContract',query: {page: page,show: show,search:search_criteria,status:status,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'updated_at',custom:custom } }"
                  >
                    Updated time
                    <small class="text-muted" v-if="label == 'updated_at'">
                      <i
                        :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                        style="font-weight:thinner;"
                      ></i>
                    </small>
                  </router-link>
                </th>
                <th class="text-right" style="width:30px !important"></th>
              </tr>
            </thead>
            <tbody>
              <template v-if="lists.length == 0">
                <tr>
                  <td colspan="9" class="text-center">No data to display</td>
                </tr>
              </template>
              <template v-else>
                <tr v-for="(list,index) in lists" :key="list.id">
                  <td>
                    <div class="abc-checkbox index-checkbox text-left">
                      <input
                        type="checkbox"
                        v-model="checkboxes1[index+1]"
                        :id="'checkbox'+(index+1)"
                        :true-value="list.amc_hdr_id"
                        :value="list.amc_hdr_id"
                        @change="event => changeCheck(event, 'checkboxes1', index+1)"
                      />
                      <label :for="'checkbox'+(index+1)" />
                    </div>
                  </td>
                  <td v-if="RoutePermission(true,'AmcContractView','','','')" class="text-nowrap">
                    <router-link
                      class="event-link theme-text-color"
                      :to="{ name : 'AmcContractView',params:{id:list.amc_hdr_id}}"
                    >{{ list.amc_no }}</router-link>
                  </td>
                  <td v-else class="btn-link text-nowrap">{{ list.amc_no }}</td>
                  <td style="max-width:180px !important">
                    <span class="text">{{ list.cus_name }}</span>
                  </td>
                  <td v-if="cus_legacy_id==3">{{list.cus_legacy_id}}</td>
                  <td style="width:180px !important">
                    <span class="text">{{ list.pdt_name }}</span>
                  </td>
                  <td class="text-right">
                    {{ getDetails(
                    $AppDetails.currency_details,
                    list.cus_currency,
                    "currency_symbol"
                    )+" "+parseFloat(list.amc_total).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}
                  </td>

                  <td
                    class="text-right"
                  >{{ parseFloat(list.total_avl_qty).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                  <td v-if="amc_start_date==1">{{ getDateFormat(list.amc_start_date) }}</td>
                  <td
                    v-if="next_service_date==1"
                    :style="{'color':getDateFormat(list.next_service_date)<getDateFormat(new Date())?'rgb(78, 152, 255)':''}"
                  >{{ getDateFormat(list.next_service_date) }}</td>
                  <td>{{ getDateFormat(list.amc_end_date) }}</td>

                  <td>{{list.amc_status_name}}</td>
                      <td v-if="created_at">
                      <span class="text">
                      {{ displayDateTime(list.created_at) }}
                      </span>
                  </td>
                    <td v-if="updated_at" >
                         <span class="text">
                      {{ displayDateTime(list.updated_at) }}
                         </span>
                  </td>
                  <td class="text-right">
                    <router-link
                      v-if="RoutePermission(false,'','','amccontract','update')"
                      class="event-link theme-text-color text-decoration-none"
                      :to="{ name : 'AmcContractUpdate',params:{id:list.amc_hdr_id}}"
                    >
                      <i class="la la-edit la-lg theme-text-color table-hover-visible"></i>
                    </router-link>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </b-col>
    </b-row>
    <b-row
      v-if="lists.length > 0"
      style="width: 100%;position: absolute;border-top:1px solid #e0e0e0"
      class="px-pad"
    >
      <b-col xl="5" md="6" lg="6" sm="8" cols="8" class="mt-2 pt-1 px-0">
        <nav class="float-left">
          <p>
            Showing {{ (total_count != 0 ) ? ((page - 1) * count) + 1 : 0 }} to {{ ((page - 1) * show) + lists.length }}
            of {{ total_count }} entries
            <span>
              <b-dropdown
                variant="link"
                size="xs"
                toggle-class="text-decoration-none"
                :text="count"
                left
              >
                <router-link
                  :to="{ name : 'AmcContract',query: {page: 1,show: 10,search:search_criteria,status:status,sort:sort,label:label,custom:custom } }"
                  class="text-decoration-none"
                >
                  <b-dropdown-item-button class="page-link" v-if="count != 10">10</b-dropdown-item-button>
                </router-link>
                <router-link
                  :to="{ name : 'AmcContract',query: {page: 1,show: 25,search:search_criteria,status:status,sort:sort,label:label,custom:custom } }"
                  class="text-decoration-none"
                >
                  <b-dropdown-item-button class="page-link" v-if="count != 25">25</b-dropdown-item-button>
                </router-link>
                <router-link
                  :to="{ name : 'AmcContract',query: {page: 1 ,show: 50,search:search_criteria,status:status,sort:sort,label:label,custom:custom } }"
                  class="text-decoration-none"
                >
                  <b-dropdown-item-button class="page-link" v-if="count != 50">50</b-dropdown-item-button>
                </router-link>
              </b-dropdown>
            </span> rows per page
          </p>
        </nav>
      </b-col>
      <b-col
        xl="2"
        md="2"
        lg="2"
        sm="4"
        cols="4"
        style="text-align: center;"
        class="mt-2 pt-1 px-0"
      >
        <div v-if="arrow">
          <a @click="left('#scrollCol')" class="mr-2">
            <i class="fa fa-angle-left mr-1 fw-bold round-icon"></i>

            <!-- <b-badge class="badge" variant="light">&lt;</b-badge> -->
          </a>
          <a @click="right('#scrollCol')">
            <i class="fa fa-angle-right ml-1 fw-bold round-icon"></i>

            <!-- <b-badge class="badge" variant="light">&gt;</b-badge> -->
          </a>
        </div>
      </b-col>
      <b-col xl="5" md="4" lg="4" sm="12" class="mt-2 pt-1 px-0 d-md-block d-none">
        <template v-if="total_count > show">
          <nav class="float-right">
            <ul class="pagination">
              <li class="page-item">
                <template v-if="page != 1">
                  <router-link
                    class="page-link"
                    :to="{ name : 'AmcContract',query: {page: page - 1 ,show: count,search:search_criteria,status:status,sort:sort,label:label,custom:custom } }"
                  >
                    <span aria-hidden="true">&laquo;</span>
                    <span class="sr-only">Previous</span>
                  </router-link>
                </template>
                <template v-else>
                  <a class="page-link" href="#" aria-label="Previous">
                    <span aria-hidden="true">&laquo;</span>
                    <span class="sr-only">Previous</span>
                  </a>
                </template>
              </li>
              <li class="page-item">
                <router-link
                  class="page-link"
                  :to="{ name : 'AmcContract',query: {page: 1 ,show: count,search:search_criteria,status:status,sort:sort,label:label,custom:custom } }"
                >First</router-link>
              </li>
              <li class="page-item">
                <template v-if="page != 1">
                  <router-link
                    class="page-link"
                    :to="{ name : 'AmcContract',query: {page: page - 1 ,show: count,search:search_criteria,status:status,sort:sort,label:label,custom:custom } }"
                  >Previous</router-link>
                </template>
                <template v-else>
                  <a href="#" class="page-link">Previous</a>
                </template>
              </li>
              <li class="page-item">
                <template v-if="total_count > (page * count)">
                  <router-link
                    class="page-link"
                    :to="{ name : 'AmcContract',query: {page: page + 1,show: count,search:search_criteria,status:status,sort:sort,label:label,custom:custom } }"
                  >Next</router-link>
                </template>
                <template v-else>
                  <a href="#" class="page-link">Next</a>
                </template>
              </li>
              <li class="page-item">
                <router-link
                  class="page-link"
                  :to="{ name : 'AmcContract',query: {page: Math.ceil(total_count / count),show: count,search:search_criteria,status:status,sort:sort,label:label,custom:custom } }"
                >Last</router-link>
              </li>
              <li class="page-item">
                <template v-if="total_count > (page * count)">
                  <router-link
                    class="page-link"
                    :to="{ name : 'AmcContract',query: {page: page + 1,show: count,search:search_criteria,status:status,sort:sort,label:label,custom:custom } }"
                  >
                    <span aria-hidden="true">&raquo;</span>
                    <span class="sr-only">Next</span>
                  </router-link>
                </template>
                <template v-else>
                  <a class="page-link" href="#" aria-label="Next">
                    <span aria-hidden="true">&raquo;</span>
                    <span class="sr-only">Next</span>
                  </a>
                </template>
              </li>
            </ul>
          </nav>
        </template>
      </b-col>
    </b-row>
    <!--  bulk delete modal -->
    <DeleteRecord
      v-on:setDelete="getDelete"
      :value="value"
      module="amccontract"
      content="The selected amc contract(s) will be deleted and cannot be retrieved later. Are you sure about deleting them?"
    ></DeleteRecord>
    <GlobalExportModal
      v-if="export_modal"
      :data="export_data"
      :columns="export_xl"
      :file_name="'Amc Contract'"
      @downloaded="export_modal=false"
    />
    <LogRecord :message="logrecords"></LogRecord>
  </div>
  </div>
</template>
  
  <script>
import { mapState, mapGetters } from "vuex";
import { scrollTable } from "@/mixins/scrollTable"; //functions call for table scroll
import RecordNotFound from "@/pages/Error/RecordNotFound";
import store from "@/store/index";
import { notificationMixin } from "@/mixins/notification";
import $ from "jquery";
import { formatDate } from "@/mixins/formatDate"; // to formatdate in y-m-d
import DeleteRecord from "@/components/Modal/DeleteModal"; // modal for deleting created amc contract used record
import LogRecord from "@/components/Modal/ErrorList"; // modal for deleting created  amc contract used record
function getPageamccontract(routeTo, next) {
  const currentPage = parseInt(routeTo.query.page) || 1;
  const show = parseInt(routeTo.query.show) || 10;
  const search = routeTo.query.search || "";
  const status = routeTo.query.status || store.state.amccontract.index_status || "";
  const label = routeTo.query.label || "";
  const sort = routeTo.query.sort || "";
  const custom = routeTo.query.custom || "";

  store
    .dispatch("amccontract/fetchLists", {
      page: currentPage,
      show: show,
      search: search,
      status: status,
      sort: sort,
      label: label,
      custom: custom
    })
    .then(response => {
      if (search != "" && response.status == 201) {
        window.Messenger().post({
          extraClasses: "messenger-fixed messenger-on-top messenger-on-center",
          message: response.data.status,
          type: "danger",
          showCloseButton: true
        });
      }
      else {
         store.dispatch("amccontract/fetchamccontractdetails");
      }
      routeTo.params.page = currentPage;
      routeTo.params.show = show;
      routeTo.params.search = search;
      routeTo.params.status = status;
      routeTo.params.label = label;
      routeTo.params.sort = sort;
      routeTo.params.custom = custom;
      next();
    });
}
export default {
  mixins: [notificationMixin, scrollTable,formatDate],
  props: {
    page: {
      type: Number,
      required: true
    },
    show: {
      type: Number,
      required: true
    },
    search: [String, Number],
    status: [String, Number],
    label: [String, Number],
    sort: [String, Number],
    custom: [String, Number]
  },
  name: "amccontract",
  components: {
    DeleteRecord,
    LogRecord,
    RecordNotFound
  },
  data() {
    return {
      arrow: false,
      export_data: [],
      export_modal: false,
      export_xl: {
        ID: "amc_no",
        Customer: "cus_name",
        Product: "pdt_name",
        "Contract Value(BCY)": "amc_total",
        "Contract Value(FCY)": "export_amc_total",
        "Avl Qty": "total_avl_qty",
        "Start Date": "amc_start_date",
        "Expiry Date": "amc_end_date",
        "Next Service Date": "next_service_date",
        Status: "amc_status_name",
        "Created Time":"created_at",
        "Updated Time":"updated_at"
      },
      amc_start_date: "",
      next_service_date: "",
      cus_legacy_id: "",
      logrecords: "", // to show log of popup funcitons
      value: [],
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center",
      showDismissibleAlert: this.$route.query.search == "" ? false : true,
      total: 10,
      checkboxes1: [],
      created_at:"",
      updated_at:"",
      CheckedCount: 0,
      modalPage: ""
    };
  },

  updated() {
    this.arrow = this.scrollbar($("#scrollCol")) ? true : false;
  },
  mounted() {
    this.arrow = this.scrollbar($("#scrollCol")) ? true : false;
  },
  methods: {
       getrefreshList(){
      var page = this.page;
      var page_show = this.show;
      const currentPage = page;
      const show = page_show;
      const search = this.$route.query.search || "";
      const status = this.$route.query.status || "";
      const update = this.$route.query.update;
      const label = this.$route.query.label || "";
      const sort = this.$route.query.sort || "";
      const custom = this.$route.query.custom || "";
      const update_status = update == true ? false : true;
       store
    .dispatch("amccontract/fetchLists", {
      page: currentPage,
      show: show,
      search: search,
      status: status,
      sort: sort,
      label: label,
      custom: custom
    })
    .then(()=>{
          this.$router.push({
            name: this.$route.name,
            query: {
              page: currentPage,
              show: show,
              search: search,
              status: status,
              sort: sort,
              label: label,
              update: update_status
            }
          })
        });
    },
    async exportModal() {
      this.export_modal = await true;
      this.export_data = await this.fetchExportData();
    },
    async fetchExportData() {
      const currentPage = parseInt(this.$route.query.page) || 1;
      const show = parseInt(this.$route.query.show) || 10;
      const search = this.$route.query.search || "";
      const status = this.$route.query.status || "";
      const label = this.$route.query.label || "";
      const sort = this.$route.query.sort || "";
      const custom = this.$route.query.custom || "";
      const response = await store
        .dispatch("amccontract/fetchexportLists", {
          page: currentPage,
          show: show,
          search: search,
          status: status,
          sort: sort,
          label: label,
          custom: custom
        })
        .then(() => {
             if(this.status_code!=200){
             window.Messenger().post({
            extraClasses:
              "messenger-fixed messenger-on-top messenger-on-center",
            message: this.status_message,
            type: this.status_type,
            showCloseButton: true,
          });
          }else{
          this.$root.$emit("bv::show::modal", "exportdata");
          return this.export;
          }
        });
      return response;
    },

    getPresentValue(arr, prop, val) {
      var hasMatch = "";
      for (var i = 0; i < arr.length; i++) {
        if (arr[i][prop] == val) {
          hasMatch = arr[i]["filter_id"];
          break;
        }
      }
      return hasMatch;
    },
    //  detelted record details
    getDelete() {
      var page = this.page;
      var page_show = this.show;
      const currentPage = page;
      const show = page_show;
      const search = this.$route.query.search || "";
      const status = this.$route.query.status || "";
      const update = this.$route.query.update;
      const label = this.$route.query.label || "";
      const sort = this.$route.query.sort || "";
      const update_status = update == true ? false : true;
      store
        .dispatch("amccontract/fetchLists", {
          page: currentPage,
          show: show,
          search: search,
          status: status,
          sort: sort,
          label: label,
          update: update_status
        })
        .then(async () => {
          this.page = await (this.lists.length == 0 && this.page != 1
            ? (this.page = 1)
            : this.page);
          this.$route.params.sort = sort;
          this.$router.push({
            name: this.$route.name,
            query: {
              page: this.page,
              show: show,
              search: search,
              status: status,
              update: update_status,
              sort: sort,
              label: label
            }
          });
        });

    if (this.status_code == 200) {
      this.logrecords =
        this.message.message.length == 0
          ? this.message.success
          : this.message.message;
      this.$root.$emit("bv::show::modal", "loglist");
     }else {
          window.Messenger().post({
            extraClasses:
              "messenger-fixed messenger-on-top messenger-on-center",
            message: this.message.message,
            type: this.message.type,
            showCloseButton: true,
          });
        }
    },
    checkAll(ev) {
      this.check_index = [];
      var fields = this;
      fields.lists.map(function(value, index) {
        fields.checkboxes1[index + 1] =
          ev.target.checked == true ? value.amc_hdr_id : false;
      });

      this.CheckedCount =
        ev.target.checked == true
          ? (this.page - 1) * this.show + this.lists.length
          : 0;
    },
    //select the checkbox//
    changeCheck(ev, checkbox, id) {
      var pdt_ids = this.checkboxes1;
      pdt_ids = pdt_ids.filter(item => item !== false);
      // check all if page length matches
      if (pdt_ids.length == this.lists.length) {
        this[checkbox][0] = true;
      }
      // uncheck if any of the checkbox is unchecked
      if (!ev.target.checked) {
        this[checkbox][0] = false;
      }
      if (this[checkbox][id] != false) {
        this.CheckedCount = parseInt(this.CheckedCount) + 1;
      } else {
        this.CheckedCount = parseInt(this.CheckedCount) - 1;
      }
    },
    //  call delete modal
    deletemodal() {
      var ids = this.checkboxes1;
      ids = ids.filter(item => item !== false && item !== true);
      this.value = ids;
      this.$root.$emit("bv::show::modal", "invoicedelete");
    }
  },
  created() {
    var check = [false];
    var i;
    for (i = 0; i < this.total; i++) {
      check.push(false);
    }

    this.checkboxes1 = check;
    this.CheckedCount = 0;
    this.initializationMessengerCode();
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air"
    };
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
      store.state.amccontract.index_status=store.state.settings.status_code!=404? store.state.amccontract.index_status:""
    store.dispatch("amccontract/fetchamccontractdetails");
    getPageamccontract(routeTo, next);
  },
  beforeRouteUpdate(routeTo, routeFrom, next) {
    store.state.amccontract.index_status = "";
    this.CheckedCount = 0;
    this.checkboxes1 = [];
    getPageamccontract(routeTo, next);
  },
  beforeRouteLeave(to, from, next) {
    store.state.amccontract.amccontract_index_history = from.fullPath;
    store.state.amccontract.index_status = from.params.status;
    store.state.settings.status_code=''
    next();
  },


  computed: {
    ...mapState({
      lists: state => state.amccontract.lists,
      total_count: state => state.amccontract.total_count,
      count: state => state.amccontract.count,
      search_criteria: state => state.amccontract.search_criteria,
      filter_list: state => state.amccontract.filter_list,
      filter_name: state => state.amccontract.filter_name,
      delete: state => state.amccontract.delete,
      message: state => state.amccontract.log_details,
      is_no_records: state => state.amccontract.is_no_records, // to check for an record in the database
      export: state => state.amccontract.export,
      status_code: state => state.amccontract.status_code, 
      status_message: state => state.amccontract.status_message, 
      status_type: state => state.amccontract.status_type,
    }),
    ...mapGetters(["isallowedroutes", "role_name"])
  }
};
</script>
  
  <style>
</style>